import { forwardRef } from 'react';

import { SearchIcon } from '@/assets/icons';
import { IInput, Input } from '@/components/common';

const Search = forwardRef<HTMLInputElement, IInput>(({ ...props }, ref) => {
  const defaultPrefixIcon = <SearchIcon className="w-4 h-4 text-neutral-n7" />;

  return <Input ref={ref} prefix={defaultPrefixIcon} {...props} />;
});

Search.displayName = 'Search';

export default Search;
